import { ManageFeatureFlags } from "@portal/components/admin/ManageFeatureFlags";
import { IslandLayout } from "@portal/components/layout/IslandLayout";
import { AdminUserMenu } from "./AdminUserMenu";

export const ManageFeatureFlagsView = () => {
	return (
		<IslandLayout userMenu={<AdminUserMenu />}>
			<div className="flex flex-col gap-[30px] w-[1000px] max-w-[1000px] h-fit mt-[25px] mx-[40px] pb-[75px]">
				<span
					data-testid="manage-feature-flags-label"
					className="text-[26px] text-gray-800 font-semibold"
				>
					Manage Feature Flags
				</span>
				<ManageFeatureFlags />
			</div>
		</IslandLayout>
	);
};
